import { CodeLevelsForm } from '@/features/factory/subfactories/CodeLevelsForm'

/** Sub-route /factory/code-levels — wraps the Code Levels form component. */
export function CodeLevelsPage() {
  return <CodeLevelsForm />
}
